<template>
    <!-- Footer start -->
    <v-footer class="custom-footer d-flex flex-column">
        <div class="bg-custom-footer w-full flex flex-col justify-center items-center gap-8 p-8">
            <!-- Overview start -->
            <div class="text-stone-100 text-center">
                <p class="tracking-widest font-semibold text-stone-100">Copyright© {{ new Date().getFullYear() }} Virtus
                    Consulting.
                    All rights reserved.</p>
            </div>
            <!-- Overview end -->

            <!-- Links start -->
            <div class="text-stone-100 flex justify-center items-center gap-8">
                <a href="#">
                    <i class="fa-brands fa-instagram socialIcon"></i>
                </a>
                <a href="#">
                    <i class="fa-brands fa-linkedin socialIcon"></i>
                </a>
                <a href="#">
                    <i class="fa-brands fa-facebook socialIcon"></i>
                </a>
            </div>
            <!-- Links end -->

            <!-- Disclaimer start -->
            <div>
                <p class="text-justify text-stone-100 text-center disclaimer">{{ $t('footer.disclaimer') }}</p>
            </div>
            <!-- Disclaimer end -->

            <!-- Contact Information start -->
            <div class="text-stone-100 flex flex-row justify-center items-start gap-8">
                <div class="flex flex-col justify-center items-center">
                    <h1 class="text-stone-100 text-center">{{ $t('footer.contactInfo') }}</h1>
                    <p class="contactInfo text-stone-100 text-center">
                        E-mail: a.mease@consultvirtus.com<br>
                        E-mail: david@consultvirtus.com<br>
                        Phone: 435-229-6541 - English<br>
                        Phone: 786-413-8919 - Spanish
                    </p>
                </div>
                <div class="flex flex-col justify-center items-center">
                    <h1 class="text-stone-100 text-center">{{ $t('footer.location') }}</h1>
                    <p class="locationInfo text-stone-100 text-center"> 1243 W Crest Rd<br>
                        Washington, Utah, 84780<br>
                        United States of America<br>
                    </p>
                </div>
            </div>
            <!-- Contact Information end -->
        </div>
                    <!-- Overview start -->
            <div class="text-justify text-stone-100 text-center powered">
                <a href="https:treedee.dev" target="blank">Powered by treedee.dev</a>
            </div>
            <!-- Overview end -->
        <!-- Footer end -->
    </v-footer>
</template>

<script>
export default {

}
</script>

<style>
.custom-footer {
    background-color: #132e63 !important;
    width: 100vw !important; /* Asegura que ocupe el 100% del ancho de la ventana */
    position: relative; /* Cambia a relative si absolute causa problemas */
    left: 0;
    right: 0;
}
.bg-custom-footer {
    background-color: #132e63 !important;
}
.disclaimer {
    font-size: 0.8rem;
    display: inline-block;
}
.contactInfo {
    font-size: 0.8rem;
    display: inline-block;
}
.locationInfo {
    font-size: 0.8rem;
    display: inline-block;
}
h1 {
    font-size: 1rem;
    font-weight: 600;
}
.powered {
    font-size: 0.7rem;
}
</style>